import React from 'react';

type Props = {
  className?: string;
  selection: number;
  onClick: (selection: number) => void;
};

export const AboutStoryPills: React.FC<Props> = props => {
  return (
    <>
      <div className={`${props.className}`}>
        <div className={'flex justify-center mt-6 group '}>
          <span
            onClick={() => props.onClick(0)}
            className={`cursor-pointer inline-flex items-center px-3 py-1.5 rounded-full text-md font-light ${
              props.selection === 0
                ? 'bg-primary-600 text-white '
                : 'bg-gray-200 text-gray-800'
            } `}
          >
            All
          </span>
          <span
            onClick={() => props.onClick(1)}
            className={`cursor-pointer ml-4 inline-flex items-center  px-3 py-1.5  rounded-full text-md font-light bg-gray-100 ${
              props.selection == 1
                ? 'bg-primary-600 text-white '
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Mission
          </span>
          <span
            onClick={() => props.onClick(2)}
            className={`cursor-pointer ml-4 inline-flex items-center  px-3 py-1.5  rounded-full text-md font-light bg-gray-100 ${
              props.selection == 2
                ? 'bg-primary-600 text-white '
                : 'bg-gray-200 text-gray-800'
            }`}
          >
            Vision
          </span>
        </div>
      </div>
    </>
  );
};
